import React from 'react';
import { StyleSheet, View } from 'react-native';
import { styles as baseStyles, FormInput, Text, theme } from '@socrait/react';

import { setupStore } from '~/store/setupStore';

import { setupStepStyles } from './setupStepStyles';

export const ClassSetupStep = () => {
  const { firstClassName, setFirstClassName, firstShortName, setFirstShortName } = setupStore();

  return (
    <View style={setupStepStyles.container}>
      <View style={setupStepStyles.headerContainer}>
        <Text style={setupStepStyles.headerText}>
          Let's set up your <Text style={setupStepStyles.headerTextPurple}>first class</Text>
        </Text>
      </View>

      <View style={setupStepStyles.contentContainer}>
        <View style={styles.speechBubbleWrapper}>
          <View style={styles.speechBubble}>
            <Text style={styles.speechBubbleText}>Choose the class where you most need an assistant</Text>
          </View>
          <View style={styles.speechBubbleArrow} />
        </View>

        <FormInput
          label="Class Name"
          onChangeText={setFirstClassName}
          placeholderText="Enter your class name"
          required={true}
          telemetryLabel="class-setup-class-name-input"
          value={firstClassName}
          variant="mobile"
        />

        <FormInput
          label="Short Name"
          maxLength={3}
          onChangeText={setFirstShortName}
          placeholderText="###"
          required={true}
          telemetryLabel="class-setup-class-period-input"
          value={firstShortName}
          variant="mobile"
        />

        <View style={styles.instructionsContainer}>
          <Text style={baseStyles.boldText}>Short name examples:</Text>
          <Text>1st, 2nd, 3rd ...</Text>
          <Text>P1, P2, P3 ...</Text>
          <Text>A1, A2, B1, B2 ...</Text>
          <Text>ADV, HR, SH ...</Text>
          <Text>MTH, SCI, ELA ...</Text>
          <Text>HR, 217, Gr4, 5th ...</Text>
          <Text>WIN, PH, INT, RTI, WTM, WTR, ML ...</Text>
          <Text>AM, PM ...</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  speechBubbleWrapper: {
    alignItems: 'flex-end',
    marginHorizontal: 'auto',
    marginBottom: -theme.spacing.medium,
    marginTop: theme.spacing.xxlarge,
  },
  speechBubble: {
    backgroundColor: theme.colors.navy,
    borderRadius: theme.borderRadius.medium,
    paddingVertical: theme.spacing.medium,
    paddingHorizontal: theme.spacing.large,
  },
  speechBubbleText: {
    color: theme.colors.white,
    fontSize: theme.fontSizes.small,
    textAlign: 'center',
  },
  speechBubbleArrow: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 10,
    borderRightWidth: 10,
    borderTopWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: theme.colors.navy,
    marginRight: theme.spacing.large,
  },
  instructionsContainer: {
    gap: theme.spacing.small,
  },
});
